import {
  AssetAnswers,
  AssetEncumbrance,
  AssetFinancialHoldingKind,
  PendingDocumentMove,
} from "../../../api/ClientFileApi";

export const AssetsMaxLength = {
  details: 4000,
  institutionName: 255,
  accountNumber: 255,
  street: 255,
  houseNumber: 30,
  zipCode: 10,
  city: 255,
  country: 30,
  remarks: 4000,
} as const;

export interface FinancialHoldingFormValue {
  key: string;
  id: string | null;
  kind: AssetFinancialHoldingKind;
  institutionName: string | null;
  accountNumber: string | null;
  street: string | null;
  houseNumber: string | null;
  zipCode: string | null;
  city: string | null;
  country: string | null;
  encumbrance: AssetEncumbrance | null;
  encumberedClaimId: string | null;
  usedForProceedingCosts: boolean | null;
  isValueKnown: boolean | null;
  value: number | null;
  valueDate: Date | null;
  remarks: string | null;
}

export type FinancialHoldingField = Exclude<keyof FinancialHoldingFormValue, "key" | "id" | "kind">;

export type AssetAnswerField = keyof AssetAnswers;

export interface AssetDocumentFiles {
  domesticRealEstateDocuments: File[];
  foreignRealEstateDocuments: File[];
  buildingSavingsContractDocuments: File[];
  savingsAccountDocuments: File[];
  lifeInsuranceDocuments: File[];
  pensionInsuranceDocuments: File[];
  securitiesDepotDocuments: File[];
  cashAndBankAssetDocuments: File[];
  vehicleDocuments: File[];
  buildingsOnForeignLandDocuments: File[];
}

export type AssetDocumentField = keyof AssetDocumentFiles;

export interface AssetsFormValues extends AssetDocumentFiles {
  answers: AssetAnswers;
  financialHoldings: FinancialHoldingFormValue[];
  documentMoves: PendingDocumentMove[];
}
